export const UITSCANNER_TEXT = {
  nl: {
    scanKistFirst: "Scan eerst een kist (kist-0001) of palletlabel en daarna machine-QR (machine-1/2/3/4).",
    kistGescand: (code) => `Kist gescand: ${code}. Scan nu de machine-QR.`,
    kistUitgescand: (machineId) => `Succesvol uitgescand (Machine ${machineId})`,
    machineCooldown: ({ machineId, minutes, seconds }) =>
      `Niet meerdere kisten achter elkaar uitscannen!! Wacht nog ${minutes} min ${seconds} sec voordat je bij machine ${machineId} de volgende kist uitscant.`,
    otherModeTitle: "MACHINE-OTHER STAAT AAN",
    otherModeDescription: "Kisten worden direct uitgescand met warmtecontrole. Palletlabels worden direct afgemeld. Scan machine-other opnieuw om deze modus uit te zetten.",
    otherModeEnabled: "Machine-other staat aan.",
    otherModeDisabled: "Machine-other staat uit.",
    otherModeScanInstruction: "Machine-other staat aan. Scan een kist of palletlabel; je hoeft geen machine-QR meer te scannen.",
    disableTemperatureCheck: "Warmtecheck uitzetten",
    enableTemperatureCheck: "Warmtecheck weer aanzetten",
    temperatureBypassTitle: "LET OP: WARMTECHECK STAAT UIT",
    temperatureBypassDescription: "Warme kisten kunnen nu worden uitgescand via machine-other.",
    temperatureCheckDisabled: "Warmtecheck uitgezet voor machine-other.",
    temperatureCheckEnabled: "Warmtecheck staat weer aan.",
    startDispatchTitle: "Nieuwe vracht kisten",
    startDispatchDescription: "Kies eerst de weekorder. Iedere uitgescande kist wordt daarna automatisch aan deze vracht gekoppeld.",
    chooseDispatchOrder: "Kies weekorder...",
    noDispatchOrdersToday: "Er zijn geen open weekorders met palletgewicht gevonden.",
    allDispatchOrdersRegistered: "Alle open weekorders met palletgewicht hebben al een vrachtregistratie.",
    resumeDispatch: "Open vracht hervatten",
    cratesShort: "kisten",
    startDispatch: "Vracht starten",
    startDispatchFirst: "Start eerst een vracht en kies de weekorder.",
    dispatchOrderRequired: "Kies eerst een weekorder.",
    dispatchStarted: (customer) => `Vracht voor ${customer} gestart.`,
    dispatchStartFailed: "Vracht starten mislukt.",
    activeDispatchTitle: "Actieve vracht",
    pauseDispatch: "Vracht pauzeren / andere kiezen",
    dispatchPaused: "Vracht gepauzeerd. Alle gegevens zijn bewaard.",
    unknownCustomer: "Onbekende klant",
    dispatchScanned: "Uitgescand",
    dispatchRetained: "Leeg apart",
    dispatchTruckNow: "Op vrachtwagen",
    addRetainedCrates: "Lege kist apart zetten",
    stopRetainedMode: "Klaar met lege kisten",
    scanRetainedCrateNow: "Scan een lege kist die niet meegaat",
    retainedCrates: "Lege kisten die niet meegaan",
    undoRetainedCrate: "Klik om deze kist alsnog mee te nemen",
    retainedCrateAdded: (barcode) => `${barcode} is leeg apart gezet.`,
    retainedCrateUndone: (barcode) => `${barcode} staat weer bij de vracht.`,
    retainedCrateFailed: "Achtergebleven kist registreren mislukt.",
    invalidRetainedCrate: "Scan een geldig kistnummer van 1 tot en met 1200.",
    noTruckCrates: "Er staan geen kisten op de vrachtwagen.",
    finalizeDispatchConfirmTitle: "Vracht afronden?",
    finalizeDispatchConfirm: (quantity) => `Weet je zeker dat ${quantity} kisten op de vrachtwagen staan?`,
    finalizeDispatchConfirmYes: "Ja, vracht afronden",
    finalizeDispatchConfirmNo: "Nee",
    finalizeDispatch: "Vracht afronden",
    dispatchFinalized: (quantity) => `Vracht afgerond met ${quantity} kisten.`,
    dispatchFinalizeFailed: "Vracht afronden mislukt.",
    savingDispatch: "Opslaan...",
    palletNotFound: (palletId) => `Pallet ${palletId} niet gevonden.`,
    palletAlreadyReady: (palletId) => `Pallet ${palletId} was al gereed gemeld.`,
    palletInvalidated: (palletId) => `Palletlabel ${palletId} is vervallen. Print nieuwe labels voor deze order.`,
    palletScanned: (label) => `Pallet gescand: ${label}. Scan nu de machine-QR.`,
    palletReadyAlert: (machineId) => `Pallet gereed gemeld (Machine ${machineId})`,
    palletReadyToast: ({ customer, weightLabel, lCode }) =>
      `Pallet gereed: ${customer} - ${weightLabel || "-"} - ${lCode || "-"}`,
    palletReadyFailed: "Pallet gereed melden mislukt.",
    palletCooldown: ({machineId, sorting, minutes, seconds}) =>
      `Wacht nog ${minutes} min ${seconds} sec voordat je op machine ${machineId} opnieuw een pallet van sortering ${sorting} afmeldt.`,
    palletWeightPrompt: (palletId) => `Uit hoeveel kg bestaat pallet ${palletId}?`,
    palletWeightInputLabel: "Palletgewicht",
    palletWeightPlaceholder: "400",
    palletWeightCancelLabel: "Annuleren",
    palletWeightContinueLabel: "Controleren",
    palletWeightEditLabel: "Wijzigen",
    palletWeightConfirmLabel: "Bevestigen",
    palletWeightInvalid: "Vul een heel palletgewicht in tussen 1 en 800 kg.",
    palletWeightConfirm: (weight) => `Het palletgewicht is ${weight} kg. Weet je het zeker?`,
    palletWeightCancelled: "Palletgewicht niet bevestigd. De pallet is nog niet gereed gemeld.",
    waitingForPalletMachine: (palletId) => `Wacht op machine-QR voor pallet: ${palletId}`,
    
    scanKistThenMachine: "Scan eerst een kist of palletlabel, daarna de machine-QR.",
    waitingForMachine: (code) => `Wacht op machine-QR voor: ${code}`,
    machine: "Machine",

    noRows: "Geen rijen ingesteld",
    row: "Rij",
    koelcel: "Koelcel",

    verwacht: "verwacht",

    logout: "Uitloggen",
    loggedInAs: "Ingelogd als",

    warning: "LET OP!!",
    closing: "Sluiten",

    //error
    unknownScan: "Onbekende scan. Scan een kist-XXXX, PALLET:... of machine-1/2/3/4.",
    uitscanError: "Uitscannen is niet gelukt (head-first / order / warme rij?).",
    uitscanOrOrderError: "Uitscannen of order-log mislukt.",
    locationError: (kist) => `Kon locatie van ${kist} niet bepalen.`,
    machineNoRows: (machineId) => `Machine ${machineId} heeft geen rijen ingesteld.`,
    wrongRow: (koelcel,rij,machineId) => ` Verkeerde Rij!  Eerst leegscannen: Koelcel ${koelcel} — Rij ${rij} voor Machine ${machineId}.`,
    noPartij12: "Machines 1 & 2 hebben geen open order/partij. Scan Partij-XXXX en start een order.",
    noPartij3: "Machine 3 heeft geen open order/partij. Scan Partij-XXXX en start een order.",
    noPartij4: "Machine 4 heeft geen open order/partij. Scan Partij-XXXX en start een order.",
    wrongMachine: (machineId) => `Verkeerde machine. Verwacht: machine-${machineId}.`,
    wrongBox: (koelcel,rij) => `locatie: Koeling: ${koelcel} Rij:${rij}, verkeerde kist!!.`,
    wrongPart: ({ perceel, soort, gewicht }) => `Deze kist niet legen, hoort bij andere partij: Goede partij is: ${perceel} / ${soort} / ${gewicht}.`,
    warmbox:"Deze Kist is nog niet afgekoeld!!",
  },

  en: {
    scanKistFirst: "Scan a box (kist-0001) or pallet label first, then scan the machine QR (machine-1/2/3/4).",
    waitingForMachine: (code) => `Waiting for machine QR for: ${code}`,
    palletNotFound: (palletId) => `Pallet ${palletId} not found.`,
    palletAlreadyReady: (palletId) => `Pallet ${palletId} was already marked ready.`,
    palletInvalidated: (palletId) => `Pallet label ${palletId} is no longer valid. Print new labels for this order.`,
    palletScanned: (label) => `Pallet scanned: ${label}. Now scan the machine QR.`,
    palletReadyAlert: (machineId) => `Pallet marked ready (Machine ${machineId})`,
    palletReadyToast: ({ customer, weightLabel, lCode }) =>
      `Pallet ready: ${customer} - ${weightLabel || "-"} - ${lCode || "-"}`,
    palletReadyFailed: "Marking pallet ready failed.",
    palletCooldown: ({machineId, sorting, minutes, seconds}) =>
      `Wait another ${minutes} min ${seconds} sec before marking another ${sorting} pallet ready on machine ${machineId}.`,
    palletWeightPrompt: (palletId) => `How many kg does pallet ${palletId} weigh?`,
    palletWeightInputLabel: "Pallet weight",
    palletWeightPlaceholder: "400",
    palletWeightCancelLabel: "Cancel",
    palletWeightContinueLabel: "Review",
    palletWeightEditLabel: "Edit",
    palletWeightConfirmLabel: "Confirm",
    palletWeightInvalid: "Enter a whole pallet weight between 1 and 800 kg.",
    palletWeightConfirm: (weight) => `The pallet weight is ${weight} kg. Are you sure?`,
    palletWeightCancelled: "Pallet weight not confirmed. The pallet has not been marked ready.",
    waitingForPalletMachine: (palletId) => `Waiting for machine QR for pallet: ${palletId}`,
   
    machine: "Machine",
    row: "Row",
    
    logout: "Log out",
    loggedInAs: "Logged in as",
    scanKistThenMachine: "Scan a box or pallet label first, then the machine QR.",


    
    kistGescand: (code) => `Box scanned: ${code}. Now scan the machine-QR.`,
    kistUitgescand: (machineId) => `Succesfully scanned out (Machine ${machineId})`,
    machineCooldown: ({ machineId, minutes, seconds }) =>
      `Do not scan out multiple boxes one after another!! Wait another ${minutes} min ${seconds} sec before scanning out the next box at machine ${machineId}.`,
    otherModeTitle: "MACHINE-OTHER IS ON",
    otherModeDescription: "Boxes are scanned out immediately after the temperature check. Pallet labels are marked ready immediately. Scan machine-other again to turn this mode off.",
    otherModeEnabled: "Machine-other is on.",
    otherModeDisabled: "Machine-other is off.",
    otherModeScanInstruction: "Machine-other is on. Scan a box or pallet label; you no longer need to scan a machine QR.",
    disableTemperatureCheck: "Turn off temperature check",
    enableTemperatureCheck: "Turn temperature check back on",
    temperatureBypassTitle: "WARNING: TEMPERATURE CHECK IS OFF",
    temperatureBypassDescription: "Warm boxes can now be scanned out through machine-other.",
    temperatureCheckDisabled: "Temperature check turned off for machine-other.",
    temperatureCheckEnabled: "Temperature check is back on.",
    startDispatchTitle: "New crate shipment",
    startDispatchDescription: "Choose the week order first. Every crate scanned out afterwards is automatically linked to this shipment.",
    chooseDispatchOrder: "Choose week order...",
    noDispatchOrdersToday: "No open week orders with pallet weight were found.",
    allDispatchOrdersRegistered: "All open week orders with pallet weight already have a shipment registration.",
    resumeDispatch: "Resume open shipment",
    cratesShort: "crates",
    startDispatch: "Start shipment",
    startDispatchFirst: "Start a shipment and choose the week order first.",
    dispatchOrderRequired: "Choose a week order first.",
    dispatchStarted: (customer) => `Shipment for ${customer} started.`,
    dispatchStartFailed: "Starting the shipment failed.",
    activeDispatchTitle: "Active shipment",
    pauseDispatch: "Pause shipment / choose another",
    dispatchPaused: "Shipment paused. All data has been saved.",
    unknownCustomer: "Unknown customer",
    dispatchScanned: "Scanned out",
    dispatchRetained: "Empty set aside",
    dispatchTruckNow: "Crates on truck",
    addRetainedCrates: "Set empty crate aside",
    stopRetainedMode: "Done with empty crates",
    scanRetainedCrateNow: "Scan an empty crate that is not going on the truck",
    retainedCrates: "Empty crates not going on the truck",
    undoRetainedCrate: "Click to put this crate back on the shipment",
    retainedCrateAdded: (barcode) => `${barcode} was set aside as empty.`,
    retainedCrateUndone: (barcode) => `${barcode} is back on the shipment.`,
    retainedCrateFailed: "Registering the crate left on site failed.",
    invalidRetainedCrate: "Scan a valid crate number from 1 through 1200.",
    noTruckCrates: "There are no crates on the truck.",
    finalizeDispatchConfirmTitle: "Finish shipment?",
    finalizeDispatchConfirm: (quantity) => `Are you sure ${quantity} crates are on the truck?`,
    finalizeDispatchConfirmYes: "Yes, finish shipment",
    finalizeDispatchConfirmNo: "No",
    finalizeDispatch: "Finish shipment",
    dispatchFinalized: (quantity) => `Shipment finished with ${quantity} crates.`,
    dispatchFinalizeFailed: "Finishing the shipment failed.",
    savingDispatch: "Saving...",
    noRows: "No rows appointed",
    koelcel: "Cooling",
    verwacht: "expected",

    warning: "WARNING!!",
    closing: "Close",

    //error
    unknownScan: "Unknown scan. Scan kist-XXXX, PALLET:... or machine-1/2/3/4.",
    uitscanError: "Scan-out failed (head-first / order / warme row?).",
    uitscanOrOrderError:  "Scan-out or order log failed.",
    locationError: (kist) =>`Could not determine location for ${kist}.`,
    machineNoRows: (machineId) => `Machine ${machineId} has no rows configured.`,
    wrongRow: (koelcel,rij,machineId) => `Wrong row. Clear this first: Cooling ${koelcel} — Row ${rij} for Machine ${machineId}.`,
    noPartij12: "Machines 1 & 2 have no open order. Scan Order-XXXX and start an order.",
    noPartij3: "Machine 3 has no open order. Scan Order-XXXX and start an order.",
    noPartij4: "Machine 4 has no open order. Scan Order-XXXX and start an order.",
    wrongMachine: (machineId) => `Wrong machine. Expected: machine-${machineId}.`,
    wrongBox: (koelcel,rij) => `Location: Cooling: ${koelcel} Row: ${rij}, Wrong Box!!.`,
    wrongPart: ({ perceel, soort, gewicht }) => `Don't empty this box, is a part of other party: Correct party is: ${perceel} / ${soort} / ${gewicht}.`,
    warmbox:"This box is not cooled!!",
},
  pl: {
    scanKistFirst: "Najpierw zeskanuj pudełko (kist-0001), a potem kod QR maszyny 1/2/3/4",
      waitingForMachine: (code) => `Czekam na kod QR maszyny  dla : ${code}`,
    
      machine: "Maszyna",
      row: "Rząd",
      
      logout: "Wyloguj się",
      loggedInAs: "Zalogowano jako",
      scanKistThenMachine: "Najpierw zeskanuj (pudełko,skrzynię),a potem kod QR maszyny.",


      
      kistGescand: (code) => `Zeskanowano pudełko: ${code}. Teraz zeskanuj kod QR maszyny.`,
      kistUitgescand: (machineId) => `Pomyślnie zeskanowano (Maszyny ${machineId})`,
      machineCooldown: ({ machineId, minutes, seconds }) =>
        `Nie skanuj kilku skrzyń jedna po drugiej!! Odczekaj jeszcze ${minutes} min ${seconds} s przed zeskanowaniem kolejnej skrzyni przy maszynie ${machineId}.`,
      otherModeTitle: "MACHINE-OTHER JEST WLACZONY",
      otherModeDescription: "Skrzynie sa natychmiast wydawane po kontroli temperatury. Etykiety palet sa natychmiast oznaczane jako gotowe. Zeskanuj machine-other ponownie, aby wylaczyc ten tryb.",
      otherModeEnabled: "Machine-other jest wlaczony.",
      otherModeDisabled: "Machine-other jest wylaczony.",
      otherModeScanInstruction: "Machine-other jest wlaczony. Zeskanuj skrzynie lub etykiete palety; nie musisz ponownie skanowac kodu maszyny.",
      disableTemperatureCheck: "Wyłącz kontrolę temperatury",
      enableTemperatureCheck: "Włącz ponownie kontrolę temperatury",
      temperatureBypassTitle: "UWAGA: KONTROLA TEMPERATURY JEST WYŁĄCZONA",
      temperatureBypassDescription: "Ciepłe skrzynie można teraz wydawać przez machine-other.",
      temperatureCheckDisabled: "Kontrola temperatury dla machine-other została wyłączona.",
      temperatureCheckEnabled: "Kontrola temperatury została ponownie włączona.",
      startDispatchTitle: "Nowy transport skrzyń",
      startDispatchDescription: "Najpierw wybierz zamówienie tygodniowe. Każda później wydana skrzynia zostanie automatycznie przypisana do tego transportu.",
      chooseDispatchOrder: "Wybierz zamówienie tygodniowe...",
      noDispatchOrdersToday: "Nie znaleziono otwartych zamówień z wagą palety.",
      allDispatchOrdersRegistered: "Wszystkie otwarte zamówienia z wagą palety mają już zarejestrowany transport.",
      resumeDispatch: "Wznów otwarty transport",
      cratesShort: "skrzyń",
      startDispatch: "Rozpocznij transport",
      startDispatchFirst: "Najpierw rozpocznij transport i wybierz zamówienie tygodniowe.",
      dispatchOrderRequired: "Najpierw wybierz zamówienie tygodniowe.",
      dispatchStarted: (customer) => `Rozpoczęto transport dla ${customer}.`,
      dispatchStartFailed: "Nie udało się rozpocząć transportu.",
      activeDispatchTitle: "Aktywny transport",
      pauseDispatch: "Wstrzymaj transport / wybierz inny",
      dispatchPaused: "Transport wstrzymany. Wszystkie dane zostały zapisane.",
      unknownCustomer: "Nieznany klient",
      dispatchScanned: "Wydano",
      dispatchRetained: "Puste odłożone",
      dispatchTruckNow: "Skrzynie na ciężarówce",
      addRetainedCrates: "Odłóż pustą skrzynię",
      stopRetainedMode: "Koniec pustych skrzyń",
      scanRetainedCrateNow: "Zeskanuj pustą skrzynię, która nie jedzie ciężarówką",
      retainedCrates: "Puste skrzynie, które nie jadą ciężarówką",
      undoRetainedCrate: "Kliknij, aby jednak dodać tę skrzynię do transportu",
      retainedCrateAdded: (barcode) => `${barcode} została odłożona jako pusta.`,
      retainedCrateUndone: (barcode) => `${barcode} jest ponownie w transporcie.`,
      retainedCrateFailed: "Nie udało się zarejestrować skrzyni pozostającej na miejscu.",
      invalidRetainedCrate: "Zeskanuj prawidłowy numer skrzyni od 1 do 1200.",
      noTruckCrates: "Na ciężarówce nie ma żadnych skrzyń.",
      finalizeDispatchConfirmTitle: "Zakończyć transport?",
      finalizeDispatchConfirm: (quantity) => `Czy na pewno ${quantity} skrzyń znajduje się na ciężarówce?`,
      finalizeDispatchConfirmYes: "Tak, zakończ transport",
      finalizeDispatchConfirmNo: "Nie",
      finalizeDispatch: "Zakończ transport",
      dispatchFinalized: (quantity) => `Zakończono transport z ${quantity} skrzyniami.`,
      dispatchFinalizeFailed: "Nie udało się zakończyć transportu.",
      savingDispatch: "Zapisywanie...",
      palletNotFound: (palletId) => `Nie znaleziono palety ${palletId}.`,
      palletAlreadyReady: (palletId) => `Paleta ${palletId} jest juz oznaczona jako gotowa.`,
      palletInvalidated: (palletId) => `Etykieta palety ${palletId} jest niewazna. Wydrukuj nowe etykiety dla tego zamowienia.`,
      palletScanned: (label) => `Zeskanowano palete: ${label}. Teraz zeskanuj kod QR maszyny.`,
      palletReadyAlert: (machineId) => `Paleta oznaczona jako gotowa (Maszyna ${machineId})`,
      palletReadyToast: ({ customer, weightLabel, lCode }) =>
        `Paleta gotowa: ${customer} - ${weightLabel || "-"} - ${lCode || "-"}`,
      palletReadyFailed: "Nie udalo sie oznaczyc palety jako gotowej.",
      palletCooldown: ({machineId, sorting, minutes, seconds}) =>
        `Odczekaj jeszcze ${minutes} min ${seconds} s przed oznaczeniem kolejnej palety ${sorting} na maszynie ${machineId}.`,
      palletWeightPrompt: (palletId) => `Ile kg wazy paleta ${palletId}?`,
      palletWeightInputLabel: "Waga palety",
      palletWeightPlaceholder: "400",
      palletWeightCancelLabel: "Anuluj",
      palletWeightContinueLabel: "Sprawdz",
      palletWeightEditLabel: "Zmien",
      palletWeightConfirmLabel: "Potwierdz",
      palletWeightInvalid: "Wpisz pelna wage palety od 1 do 800 kg.",
      palletWeightConfirm: (weight) => `Waga palety wynosi ${weight} kg. Czy na pewno?`,
      palletWeightCancelled: "Waga palety nie zostala potwierdzona. Paleta nie zostala oznaczona jako gotowa.",
      waitingForPalletMachine: (palletId) => `Czekam na kod QR maszyny dla palety: ${palletId}`,
      
      noRows: "Nie wyznaczono Żadnych wierszy ",
      koelcel: "Chłodnia",
      verwacht: "Oczekuje",
      
      warning: "Ostrzeżenie!!",
      closing: "Zamykać",

      //error
      unknownScan: "Nie znane skanowanie. Przeskanuj (skrzynię,pudełko) lub maszynę 1,2,3,4",
      noPartij4: "Maszyna 4 nie ma otwartego zlecenia/partii. Zeskanuj Partia-XXXX i uruchom zlecenie.",
      uitscanError: "Skanowanie niepowiodło się(zamówienie ,ciepły rząd)",
      uitscanOrOrderError:  "Skanowanie lub rejestrowanie zamówień nie powiodło się.",
      locationError: (kist) =>`Nie można ustalić lokalizacji dla  ${kist}.`,
      machineNoRows: (machineId) => `Maszyna ${machineId}  nie ma skonfigurowanych wierszy.`,
      wrongRow: (koelcel,rij,machineId) => `Zły wiersz najpierw usuń to: ${koelcel} — Row ${rij} for Machine ${machineId}.`,
      wrongMachine: (machineId) => `Nieprawidłowa maszyna. Oczekiwano: Maszyna-${machineId}.`,
      wrongBox: (koelcel,rij) => `Lokalizacja chłodnia: ${koelcel} Rząd: ${rij}, Złe pudełko(skrzynia)!!.`,
      wrongPart: ({ perceel, soort, gewicht }) => `Don't empty this box, is a part of other party: Correct party is: ${perceel} / ${soort} / ${gewicht}.`,
      warmbox:"This box is not cooled!!",
    }

};

export function getT(dict, lang) {
  return dict[lang] || dict.nl;
}
